import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationService } from '../../shared/providers/validation.service'
import { ToastService } from '../../shared/providers/toast.service'
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { IPropertyFileUpload } from '../models/fileupload';
import { AuthService } from '../auth/auth.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { LoaderService } from '../providers/loader.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { CommonService } from '../providers/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  @ViewChild('ImageUploadedProgress', { static: true }) ImageUploadedListModal: TemplateRef<any>;
  constructor(public Validation: ValidationService, public _auth0: AuthService, private modalService: BsModalService, public router: Router, private _toastService: ToastService, private authService: AuthenticationService, private _commonService: CommonService,
    private _loaderService: LoaderService, private recaptchaV3Service: ReCaptchaV3Service
) {

  }
  isUserLoggedIn = false;
  currentYear = 2019;
  uploadedPropertyFiles: IPropertyFileUpload[] = [];
  modalClose: BsModalRef;
  modalSubscribeRef: BsModalRef;
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  isValidEmail = true as boolean;
  validFname = true as boolean;
  validLname = true as boolean;
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response;
      if (this.isUserLoggedIn) {
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        if (loggedUserDetails != null && loggedUserDetails != undefined) {
          this.firstName = loggedUserDetails.FirstName;
          this.lastName = loggedUserDetails.LastName;
          this.email = loggedUserDetails.UserName;
        }
      }

    });
    this._auth0.GetUploadedImages();
  }
  subscriptionEmail = "";
  user = [];
  onSubmit(e) {

  }

  invalidSubscriptionEmail = false;
  checksubscriptionEmail(event) {
    if (this.Validation.isEmail(this.subscriptionEmail)) {
      this.invalidSubscriptionEmail = false;
    }
    else {
      this.invalidSubscriptionEmail = true;
    }
  }
  onSubscription() {
    JSON.parse(localStorage.getItem('UploadedImageList'))
    let data = $('#mauticForm').serialize();
    $.ajax({
      url: 'https://mautic.benetlease.com/form/submit?formId=2',
      type: 'post',
      dataType: 'json',
      data: data,
      success: function (data) { }
    });
    this._toastService.addToast({ title: 'Subscribed Successfully', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    this.subscriptionEmail = "";
  }
  scrollTop() {
    this.Validation.scrollTop();
  }
  OnClose(template: TemplateRef<any>, classes) {
    if (this._auth0.imagesList != null) {
      if (this._auth0.FailedImageCount > 0) {
        const config = {
          ignoreBackdropClick: true,
          class: 'modal-position commonmodal close-image-uploader',
          keyboard: false,
          backdrop: true
        }
        this.modalClose = this.modalService.show(template, { class: classes });
      }
      else {
        this.ConfirmClosing();
      }
    }
    else {
      this.ConfirmClosing();
    }
  }
  ConfirmClosing() {
    localStorage.setItem('mydata', JSON.stringify(this._auth0.uploadedFiles))
    this._auth0.imagesList = JSON.parse(localStorage.getItem('mydata'))
    this._auth0.imagesList = of([]);
    localStorage.removeItem('UploadedImageList');
    if (localStorage.getItem('UploadedImageList') != null && localStorage.getItem('UploadedImageList') != '') {
      localStorage.removeItem('UploadedImageList');
    }
  }
  OnCollapse(status: boolean) {
    this._auth0.showImageStatus = status == true ? false : true;
  }
  OnRedirection(propertyGuid: string, sourceurl: string) {
    window.scrollTo(0, 0);
    if (propertyGuid != null && propertyGuid != '') {
      let url = '/viewproperty/' + propertyGuid;
      this.router.navigateByUrl(url);
    }
    else {
      this.router.navigateByUrl(sourceurl);
    }
  }
  openSubscribeModal(template: TemplateRef<any>, classes: any) {
    //const config = {
    //  class: 'news-letter-modal'
    //}
    //this.modalSubscribeRef = this.modalService.show(template, config);
    window.open('https://info.tradenetlease.com/managesubscription?' + encodeURIComponent('utm_medium=link&utm_source=be_web&utm_campaign=managesub&utm_content=button'), '_blank');
  }
  subscribe() {
    this.emailValidate()
    this.validatione(1)
    this.validatione(2)
    if (this.validFname && this.validLname && this.isValidEmail) {

      this.recaptchaExecute();
    }
  }
  emailValidate() {
    if (this.Validation.isEmail(this.email)) {
      this.isValidEmail = true;
    }
    else {
      this.isValidEmail = false;
    }
  }

  validatione(fieldType) {
    switch (fieldType) {
      case 1:
        if (this.firstName) {

          this.validFname = true;
        }
        else {
          this.validFname = false;

        }
        break;
      case 2:
        if (this.lastName) {
          this.validLname = true;
        }
        else {
          this.validLname = false;
        }
        break;
    }
  }

  recaptchaExecute() {
    let that = this;
    this.recaptchaV3Service.execute('subscribe')
      .subscribe((token) => {
        that._commonService.decodereCaptchaToken(token).subscribe(res => {
          if (res)
            console.log(res);
          if (res["Score"] > 0.5) {
            this.submitSubscribe()
          }
          //else {
          //this._toastService.addToast({ title: 'Please check captcha', msg: '', timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          //}
        })
      });
  }
  submitSubscribe() {
    this._loaderService.display(true);
    var contact = {
      "FirstName": this.firstName,
      "LastName": this.lastName,
      "Email": this.email,
    };

    this._commonService.SubscribeEmail(contact).subscribe(res => {
      if (res)
        this.modalSubscribeRef.hide();
      this._loaderService.display(false);
      this._toastService.addToast({ title: 'Subscribed Successfully', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      if (!this.isUserLoggedIn) {
        this.email = "";
        this.firstName = "";
        this.lastName = "";
        this.companyName = "";
      }

    })
  }



}
